import { z } from 'zod';

export const MISCONFIG_ASSESSMENT_LEVELS = ['HIGH', 'MEDIUM', 'LOW'] as const;

export const MisconfigAssessmentLevelSchema = z.enum(
  MISCONFIG_ASSESSMENT_LEVELS,
);

export type MisconfigAssessmentLevel =
  (typeof MISCONFIG_ASSESSMENT_LEVELS)[number];

export const MISCONFIG_TECHNOLOGY_ASSESSMENT_STATUSES = [
  'PENDING',
  'COMPLETED',
  'FAILED',
] as const;

export const MisconfigTechnologyAssessmentStatusSchema = z.enum(
  MISCONFIG_TECHNOLOGY_ASSESSMENT_STATUSES,
);

export type MisconfigTechnologyAssessmentStatus =
  (typeof MISCONFIG_TECHNOLOGY_ASSESSMENT_STATUSES)[number];

export const MISCONFIG_TECHNOLOGY_ASSESSMENT_RATIONALE_MAX_LENGTH = 500;

export const MisconfigTechnologyAssessmentRequestIdSchema = z.string().uuid();

export const MISCONFIG_TECHNOLOGY_ASSESSMENT_REQUEST_SOURCES = {
  TECH_STACK_CHANGE: 'tech-stack-change',
  BACKFILL: 'backfill',
  ENDPOINT_CODE_GRAPH: 'endpoint-code-graph',
} as const;

export const MisconfigTechnologyAssessmentOutputSchema = z.object({
  level: MisconfigAssessmentLevelSchema,
  rationale: z
    .string()
    .trim()
    .min(1)
    .max(MISCONFIG_TECHNOLOGY_ASSESSMENT_RATIONALE_MAX_LENGTH),
});

export type MisconfigTechnologyAssessmentOutput = z.infer<
  typeof MisconfigTechnologyAssessmentOutputSchema
>;

export const MisconfigTechnologyAssessmentSchema = z.object({
  technologyKey: z.string(),
  technologyName: z.string(),
  status: MisconfigTechnologyAssessmentStatusSchema,
  level: MisconfigAssessmentLevelSchema.nullable(),
  rationale: z.string().nullable(),
  error: z.string().nullable(),
  promptVersion: z.string().nullable(),
  assessedAt: z.string().nullable(),
  requestedBy: z.string(),
  autoResearchRequestedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type MisconfigTechnologyAssessmentDto = z.infer<
  typeof MisconfigTechnologyAssessmentSchema
>;

export const MisconfigTechnologyAssessmentCompletedPayloadSchema =
  z.discriminatedUnion('outcome', [
    z.object({
      outcome: z.literal('completed'),
      technologyKey: z.string().min(1),
      requestId: MisconfigTechnologyAssessmentRequestIdSchema,
      level: MisconfigAssessmentLevelSchema,
      rationale: z
        .string()
        .trim()
        .min(1)
        .max(MISCONFIG_TECHNOLOGY_ASSESSMENT_RATIONALE_MAX_LENGTH),
      promptVersion: z.string().min(1),
    }),
    z.object({
      outcome: z.literal('failed'),
      technologyKey: z.string().min(1),
      requestId: MisconfigTechnologyAssessmentRequestIdSchema,
      promptVersion: z.string().min(1),
      error: z.string().min(1),
    }),
  ]);

export type MisconfigTechnologyAssessmentCompletedPayload = z.infer<
  typeof MisconfigTechnologyAssessmentCompletedPayloadSchema
>;
